const SET_BEHAVIOUR = (state, data) => {
  state.created = new Date().toString()
  state.hasApp = data.hasApp
  state.hasBoughtDeal = data.hasBoughtDeal
  state.hasLocalNumber = data.hasLocalNumber
  state.hasRebtelCredit = data.hasRebtelCredit
  state.hasRecharge = data.hasRecharge
  state.inRebtelCountry = data.inRebtelCountry
  state.hasSim = data.hasSim
  state.isActivist = data.isActivist
}
export default {
  SET_BEHAVIOUR
}



// WEBPACK FOOTER //
// ./src/store/modules/user/behavior/mutations.js